import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_API_URL } from "../constant";
import { useNavigate } from "react-router-dom";
import OtpInput from 'react-otp-input';
import './BoxInput.css';
import utubelogo from '../images/utubelogo.png';
import AdSenseAds from "./AdSenseAds";

function formatDate(timestamp) {
    function addOrdinalSuffix(day) {
        if (day > 3 && day < 21) return day + 'th';
        switch (day % 10) {
            case 1: return day + 'st';
            case 2: return day + 'nd';
            case 3: return day + 'rd';
            default: return day + 'th';
        }
    }

    const dayWithOrdinal = addOrdinalSuffix(timestamp.getDate());

    // Array of month names
    const monthNames = [
        'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
        'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
    ];

    // Format the date as "26th August, 2023"
    const formattedDate = `${dayWithOrdinal} ${monthNames[timestamp.getMonth()]}, ${timestamp.getFullYear()}`;

    return formattedDate;
}

function PredictNumber() {
    const Navigate = useNavigate();

    const [isPredicted, setisPredicted] = useState(false);
    const [predictionNumber, setPredictionNumber] = useState('');
    const [yesterdayPredictionNumber, setYesterdayPredictionNumber] = useState('');
    const [yesterdayWinningNumber, setYesterdayWinningNumber] = useState('');
    const [todayPredictionNumber, setTodayPredictionNumber] = useState(null);
    const [isBefore830PM, setIsBefore830PM] = useState(false);
    const [wantEdit, setWantEdit] = useState(false);
    const [editCount, setEditCount] = useState(Number);
    const token = localStorage.getItem("token");

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    useEffect(() => {
        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        async function getEditCount() {
            await axios.get(`${BASE_API_URL}api/user/edit_count`, config).then((res) => {
                setEditCount(res.data.editCount);
            })
        }
        getEditCount();

        async function fetchData() {
            const token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            await axios.get(BASE_API_URL + "api/winning/user/prediction_number", config).then((res) => {
                const data = res.data;

                const currentDate = new Date().toISOString().split('T')[0];

                // Calculate yesterday's date by subtracting one day from the current date
                const yesterdayDate = new Date();
                yesterdayDate.setDate(yesterdayDate.getDate() - 1);
                const formattedYesterdayDate = yesterdayDate.toISOString().split('T')[0];

                let lastUpdatedPredictionNumber = null;

                // Iterate through the data to find the prediction_numbers
                data.forEach((item) => {
                    if (item.transaction_date.startsWith(currentDate)) {
                        setisPredicted(true);
                        if (lastUpdatedPredictionNumber === null || item.updatedAt > lastUpdatedPredictionNumber.updatedAt) {
                            lastUpdatedPredictionNumber = item;
                            setTodayPredictionNumber(item.prediction_number);
                        }
                    } else if (item.transaction_date.startsWith(formattedYesterdayDate)) {
                        setYesterdayPredictionNumber(item.prediction_number);
                    }
                });
            }).catch((err) => {
                console.log(err);
            });

            await axios.get(`${BASE_API_URL}api/winning/winning_numbers`)
                .then(res => {
                    const currentDate = new Date();

                    // Subtract one day to get yesterday's date
                    const yesterdayDate = new Date(currentDate);
                    yesterdayDate.setDate(currentDate.getDate() - 1);

                    // Convert both dates to strings and extract only the date part
                    // const currentDateStr = currentDate.toISOString().slice(0, 10);
                    const yesterdayDateStr = yesterdayDate.toISOString().slice(0, 10);

                    let yesterdayWinningNumber = null;

                    // Loop through the data and find yesterday's winning number
                    for (const item of res.data) {
                        if (item.created_date_time.startsWith(yesterdayDateStr)) {
                            yesterdayWinningNumber = item.winning_number;
                            break; // Stop once you find the winning number for yesterday
                        }
                    }
                    setYesterdayWinningNumber(yesterdayWinningNumber);
                })
                .catch(err => {
                    console.log(err);
                });


            // Function to check if the current time is before 8:30 PM
            function checkTime() {
                const currentDate = new Date();
                const currentHour = currentDate.getHours();
                const currentMinute = currentDate.getMinutes();

                // Compare with 20 (8 PM) and 30 (8:30 PM)
                setIsBefore830PM(currentHour < 20 || (currentHour === 20 && currentMinute < 30));
            }

            // Call the checkTime function when the component mounts
            checkTime();

            // Update the time check every minute
            const intervalId = setInterval(checkTime, 60000);

            const now = new Date();
            const midnight = new Date(now);
            midnight.setHours(24, 0, 0, 0);
            const timeUntilMidnight = midnight - now;

            const dailyResetTimer = setInterval(() => {
                setEditCount(0);
            }, timeUntilMidnight); // Reset daily

            // Clean up the interval when the component unmounts
            return () => {
                clearInterval(intervalId);
                clearInterval(dailyResetTimer);
            }
        }
        fetchData();
    }, []);

    function handleWantEdit() {
        setWantEdit(true);
        setisPredicted(false);
    }

    async function handlePredictionWN(e) {
        e.preventDefault();
        if (predictionNumber === "") {
            alert("Please enter a number");
            return;
        }
        if (predictionNumber.length < 5) {
            alert("Please enter 5 digit number !")
        }

        await axios.post(BASE_API_URL + "api/winning/user/prediction_number", {
            predictionNumber,
        }, config).then((req, res) => {
            Navigate("/user/history");
            if (wantEdit) {
                const getEditCount = async () => {
                    await axios.post(`${BASE_API_URL}api/user/edit_count`, { decrementValue: 1 }, config);
                    await axios.get(`${BASE_API_URL}api/user/edit_count`, config).then((res) => {
                        setEditCount(res.data.editCount);
                    })
                }
                getEditCount();
                alert("Prediction Number Updated Successfully");
            }
            else {
                const getEditCount = async () => {
                    await axios.post(`${BASE_API_URL}api/user/per_day_edit_count`, { incrementValue: 3 }, config);
                    await axios.get(`${BASE_API_URL}api/user/edit_count`, config).then((res) => {
                        setEditCount(res.data.editCount);
                    })
                }
                getEditCount();
                alert("Prediction Number Added Successfully");
            }

        }).catch((err) => {
            console.log(err);
        });

    }

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);

    return (
        <div className="text-center">
            <div className="bg-white p-3">
                {isBefore830PM ?
                    <div>
                        {isPredicted ? <h3 className="text-center">YOU HAVE ALREADY PREDICTED </h3> :
                            <>
                                {
                                    wantEdit ?
                                        <h3 className="text-center pt-3 px-2">UPDATE YOUR 5 DIGIT PREDICTION NUMBER</h3>
                                        :
                                        <h3 className="text-center pt-3 px-2">ENTER YOUR 5 DIGIT PREDICTION NUMBER</h3>
                                }
                            </>
                        }

                        <h6 className="text-center mb-3">FOR {formatDate(new Date())}, DRAW @ 9 PM IST</h6>
                        {isPredicted
                            ?
                            <>
                                <h3 className="text-center mb-3">Your Prediction Number is {todayPredictionNumber}</h3>
                                {
                                    editCount <= 0 ?
                                        <h3 className="text-center mb-3 text-danger">You have reached your daily edit limit</h3>
                                        :
                                        <>
                                            <h4 className="text-center mb-3">Want to edit your prediction number</h4>
                                            <h4 className="text-center mb-3 text-warning">{editCount} edit left</h4>
                                            <button onClick={handleWantEdit} type="submit" className="btn btn-success w-50 rounded-pill mb-4">Edit</button>
                                        </>

                                }
                            </>
                            :
                            <>
                                <form onSubmit={handlePredictionWN}>
                                    <div className="form-group mb-2">
                                        <div className="d-flex justify-content-center">
                                            <OtpInput
                                                value={predictionNumber}
                                                onChange={setPredictionNumber}
                                                numInputs={5}
                                                shouldAutoFocus={true}
                                                inputStyle={{ width: "50px", height: "50px", }}
                                                renderInput={(props) => <input {...props} type="number" />}
                                            />
                                        </div>
                                    </div>
                                    <h6 className="text-success mb-3">terms & conditions apply*</h6>
                                    <button type="submit" className="btn btn-success w-50 rounded-pill mb-4">SUBMIT</button>
                                </form>
                            </>
                        }
                    </div>
                    :
                    <div>
                        <h3 className="text-center text-warning mb-3">All entries are closed for today. You can come back and predict for tomorrow after 12 Midnight.</h3>
                    </div>
                }
                <h3 className="text-center mb-1">Yesterday's Winning Number ({formatDate(currentDate)}) </h3>
                <div className="d-flex justify-content-center bg-success  p-3 text-center rounded-pill">
                    <h4 className="text-center align-self-center text-white">{yesterdayWinningNumber != null ? yesterdayWinningNumber : "N/A"}</h4>
                    <img style={{ marginLeft: 20, width: "70px", height: "70px", border: "2px solid white", borderRadius: "100%" }} src={utubelogo} alt="utubelogo" />
                    <div style={{ marginLeft: 20, color: "white" }}>
                        <h4 className="text-dark">Your prediction</h4>
                        <h4><strong>{yesterdayPredictionNumber}</strong></h4>
                    </div>
                </div>
            </div>
            <AdSenseAds />
        </div >
    )
}

export default PredictNumber;